<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid u-mb-medium">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Dashboard</h1>
                    <div style="display: inline-block; float: right; margin-top: -40px;">
                        <el-date-picker
                            v-model="daterange"
                            type="daterange"
                            format="dd MMM yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Start"
                            @change="dateChanged"
                            :picker-options="datePickerOptions"
                            end-placeholder="End">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-12">
                    <div class="c-card u-p-small">
                        <div class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small">
                            <h5 class="c-card__title">Performa Scoring Outlet</h5>
                            <div class="c-card__meta">
                                <div class="custom_toolbar">
                                    <Select2 v-model="params.region2" :options="regions" :settings="{ width: '150px', placeholder: 'Region' }" @change="filter2Region($event)"/>
                                    <Select2 v-model="params.branch2" :options="branches2" :settings="{ width: '150px', placeholder: 'Branch' }" @change="filter2Branch($event)"/>
                                    <!-- <Select2 v-model="params.outlet2" :options="outlets2" :settings="{ width: '150px', placeholder: 'Outlet' }" @change="filter2Outlet($event)"/> -->
                                    <Select2 v-model="params.positions2" :options="positions" :settings="{ width: '150px', placeholder: 'Posisi' }" @change="filter2Position($event)"/>
                                    <Select2 v-model="params.author2" :options="authors" :settings="{ width: '150px', placeholder: 'Penilai' }" @change="filter2Author($event)"/>
                                    <Select2 v-model="params.authorid2" :options="author_ids2" :settings="{ width: '150px', placeholder: 'Nama Penilai' }" @change="filter2AuthorID($event)"/>
                                    <el-button size="mini" icon="el-icon-refresh-left" @click="reset2">Reset</el-button>
                                    <!-- <el-button size="mini" icon="el-icon-download"></el-button> -->
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%; overflow-x: scroll;overflow-y: hidden;height: 350px;">
                            <GChart v-loading="loading2"
                                type="ColumnChart"
                                :data="chartData2"
                                :options="chartOptions2"
                                :events="chartEvents"
                                ref="gChart2"
                            />
                        </div>
                        <!-- <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="rows"></column-chart> -->
                    </div>

                    <div class="c-card u-p-small u-mt-small">
                        <div class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small">
                            <h5 class="c-card__title">Performa Jumlah Penilaian Kunjungan<br/>BV ke Outlet</h5>
                            <div class="c-card__meta">
                                <div class="custom_toolbar">
                                    <Select2 v-model="params.region" :options="regions" :settings="{ width: '150px', placeholder: 'Region' }" @change="filter1Region($event)"/>
                                    <Select2 v-model="params.branch" :options="branches" :settings="{ width: '150px', placeholder: 'Branch' }" @change="filter1Branch($event)"/>
                                    <!-- <Select2 v-model="params.outlet" :options="outlets" :settings="{ width: '150px', placeholder: 'Outlet' }" @change="filter1Outlet($event)"/> -->
                                    <Select2 v-model="params.positions" :options="positions" :settings="{ width: '150px', placeholder: 'Posisi' }" @change="filter1Position($event)"/>
                                    <Select2 v-model="params.author" :options="authors" :settings="{ width: '150px', placeholder: 'Penilai' }" @change="filter1Author($event)"/>
                                    <Select2 v-model="params.authorid" :options="author_ids" :settings="{ width: '150px', placeholder: 'Nama Penilai' }" @change="filter1AuthorID($event)"/>
                                    <el-button size="mini" icon="el-icon-refresh-left" @click="reset">Reset</el-button>
                                    <!-- <el-button size="mini" icon="el-icon-download"></el-button> -->
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%; overflow-x: scroll;overflow-y: hidden;height: 350px;">
                            <GChart v-loading="loading"
                                type="ColumnChart"
                                :data="chartData"
                                :options="chartOptions"
                                :events="chartEvents"
                                ref="gChart"
                            />
                        </div>
                        <!-- <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="rows"></column-chart> -->
                    </div>     
                        
                </div>
            </div>
            <!-- <div class="row u-mt-medium">
                <div class="col-8">
                    <div class="c-card u-p-small">
                        <div class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small">
                            <h5 class="c-card__title">Rating BNI Region</h5>
                            <div class="c-card__meta">
                                <div class="custom_toolbar">
                                    <Select2 v-model="params.region" :options="regions" :settings="{ width: '150px', placeholder: 'Region' }" @change="myChangeEvent($event)"/>
                                    <Select2 v-model="params.branch" :options="branches" :settings="{ width: '150px', placeholder: 'Branch' }" @change="myChangeEvent2($event)"/>
                                    <Select2 v-model="params.outlet" :options="outlets" :settings="{ width: '150px', placeholder: 'Outlet' }" @change="myChangeEvent3($event)"/>
                                    <el-button size="mini" icon="el-icon-refresh-left" @click="reset">Reset</el-button>
                                    <el-button size="mini" icon="el-icon-download"></el-button>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%; overflow-x: scroll;overflow-y: hidden;height: 350px;">
                            <GChart v-loading="loading"
                                type="ColumnChart"
                                :data="chartData"
                                :options="chartOptions"
                                :events="chartEvents"
                                ref="gChart"
                            />
                        </div>
                    </div>

                    <div class="c-card u-p-small u-mt-small">
                        <div class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small">
                            <h5 class="c-card__title">Rating BNI Category</h5>
                            <div class="c-card__meta">
                                <div class="custom_toolbar">
                                    <Select2 v-model="params.region" :options="regions" :settings="{ width: '150px', placeholder: 'Region' }" @change="myChangeEvent($event)"/>
                                    <Select2 v-model="params.branch" :options="branches" :settings="{ width: '150px', placeholder: 'Branch' }" @change="myChangeEvent2($event)"/>
                                    <Select2 v-model="params.outlet" :options="outlets" :settings="{ width: '150px', placeholder: 'Outlet' }" @change="myChangeEvent3($event)"/>
                                    <el-button size="mini" icon="el-icon-refresh-left" @click="reset">Reset</el-button>
                                    <el-button size="mini" icon="el-icon-download"></el-button>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%; overflow-x: scroll;overflow-y: hidden;height: 350px;">
                            <GChart v-loading="loading2"
                                type="ColumnChart"
                                :data="chartData2"
                                :options="chartOptions2"
                                :events="chartEvents"
                                ref="gChart"
                            />
                        </div>
                    </div>     
                        
                </div>
                <div class="col-4">
                    <div class="c-card u-p-medium u-text-center">
                        <pie-chart suffix="%" :colors="['#4477ff', '#ff456b']" :data="pieData"></pie-chart>
                        <small class="u-text-mute u-mt-small" style="display: block;">From {{pieDataTotal}} Total Rating</small>
                    </div>
                    <div class="c-graph-card u-mt-small" v-if="rows">
                        <h4 class="u-p-small">Top 10 Average Rate</h4>
                        <div class="c-graph-card__footer u-p-zero">
                            <div class="u-flex u-justify-between u-align-items-center u-border-bottom u-p-small" v-for="(item,index) in rows" :key="index">
                                <span class="u-text-small u-color-primary">
                                    {{item.name}} /
                                    <span class="u-text-italic">
                                        {{item.total_rating == 1 ? `${item.total_rating} rating` : `${item.total_rating} ratings`}}
                                    </span>
                                </span>
                                <div class="u-text-right u-color-primary">
                                    <el-rate disabled show-score text-color="#ff9900" score-template="{value}" :value="parseFloat(item.average.toFixed(2))"></el-rate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="row u-mt-small">
                <div class="col-6">
                    <div class="c-card u-p-medium">
                        <h4 class="u-h5 u-mb-small">Top 10 Positive Rating</h4>
                        <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="positive"></column-chart>
                    </div>        
                </div>
                <div class="col-6">
                    <div class="c-card u-p-medium">
                        <h4 class="u-h5 u-mb-small">Top 10 Negative Rating</h4>
                        <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#ff456b'}" :data="negative"></column-chart>
                    </div>        
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import user from '@/api/admin'
    import api from '@/api/ratings'
    import categories from '@/api/categories'
    import branches from '@/api/branches'
    import regions from '@/api/regions'
    import outlets from '@/api/outlets'
    import { GChart } from 'vue-google-charts'
    import Select2 from 'v-select2-component';
    import moment from 'moment'
    export default {
        name: 'dashboard',
        components: {
            GChart,
            Select2
        },
        data() {
            return {
                chartEvents: {
                    'select': () => {
                        // const table = this.$refs.gChart.chartObject;
                        // const selection = table.getSelection();
                        // var row = selection[0].row;
                        // this.params.region = this.regions[selection[0].row].id
                        // this.fetchBranches()
                        // this.fetch()
                    }
                },
                daterange: [],
                datePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                chartData: [],
                chartData2: [],
                chartOptions: {
                    colors: ['#4477ff', '#ff456b'],
                    legend: {'position': 'none'},
                    chartArea:{left:50,top:20,width:"100%",height:"100%",bottom: 80},
                    width: 65,
                    bar: {groupWidth: 40},
                    height: 350,
                    hAxis : { 
                        textStyle : {
                            fontSize: 10 // or the number you want
                        }
                    },
                    vAxis : { 
                        textStyle : {
                            fontSize: 10 // or the number you want
                        },
                        // gridlines: { count: -1},
                        minValue: 4,     
                        viewWindow:{min:0}, /*this also makes 0 = min value*/         
                        format: '0'
                    },
                    tooltip: { textStyle: { fontSize: 10 } }
                },
                chartOptions2: {
                    colors: ['#4477ff', '#ff456b'],
                    legend: {'position': 'none'},
                    chartArea:{left:50,top:20,width:"100%",height:"100%",bottom: 80},
                    width: 65,
                    bar: {groupWidth: 40},
                    height: 350,
                    hAxis : { 
                        textStyle : {
                            fontSize: 10 // or the number you want
                        }
                    },
                    vAxis : { 
                        textStyle : {
                            fontSize: 10 // or the number you want
                        },
                        // gridlines: { count: -1},
                        minValue: 4,     
                        viewWindow:{min:0}, /*this also makes 0 = min value*/         
                        format: '0'
                    },
                    tooltip: { textStyle: { fontSize: 10 } }
                },
                rows: [],
                positive: [],
                negative: [],
                loading: true,
                loading2: true,
                pieData: [],
                pieDataTotal: 0,
                loadingPie: true,
                regions: [],
                branches: [],
                outlets: [],
                author_ids: [],
                positions: [
                    {
                        id: '-',
                        text: 'Posisi'
                    },
                    {
                        id: '0-',
                        text: 'Semua Posisi'
                    },
                    {
                        id: '0-Pimpinan',
                        text: 'Pimpinan'
                    },
                    {
                        id: '0-Customer Service',
                        text: 'Customer Service'
                    },
                    {
                        id: '0-Teller',
                        text: 'Teller'
                    },
                    {
                        id: '0-Satpam',
                        text: 'Satpam'
                    },
                    {
                        id: '1-',
                        text: 'Premise'
                    }
                ],
                authors: [
                    {
                        id: 0,
                        text: 'Penilai'
                    },
                    {
                        id: 1,
                        text: 'Admin Pusat'
                    },
                    {
                        id: 2,
                        text: 'Admin Wilayah'
                    }
                ],
                branches2: [],
                outlets2: [],
                author_ids2: [],
                params: {
                    q: '',
                    region: '',
                    branch: '',
                    outlet: '',
                    is_facility: '',
                    position: '',
                    author: '',
                    region2: '',
                    branch2: '',
                    outlet2: '',
                    is_facility2: '',
                    position2: '',
                    author2: ''
                }
            }
        },
        mounted () {
            let end = new Date()
            var start = moment(start).subtract(1, 'months')._d;
            this.daterange = [start, end]
            let relation_code = localStorage.getItem('relation_code')
            this.fetchRegions()
            this.fetchCategories()
            if(relation_code==='null') {
                this.params.region = ''
                this.params.region2 = ''
            } else {
                this.params.region = relation_code
                this.params.region2 = relation_code
                this.fetchBranches()
                this.fetchBranches2()
            }
            this.fetchActive();
            this.fetchScore();
            // this.fetch();
            // this.fetchByCategory();
            // this.fetchTop();
            // this.fetchGeneral();
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            fetchActive() {
                this.loading = true
                var self = this
                api.getActive(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), this.params.is_facility, this.params.position, this.params.author, this.params.authorid)
                .then(function (response) {
                    let data = [['Wilayah', 'Total']]
                    if(response.data.data.length > 0){
                        response.data.data.forEach(element => {
                            if(element.code!=='999'){
                            data.push([element.name, parseInt(element.total)])
                            }
                        });
                        // self.rows = data
                        self.chartOptions.width = data.length * 65
                        self.chartData = data
                        self.loading = false
                    } else {
                        data.push(['No data', 0])
                        self.chartData = data
                        self.loading = false
                        // api.getActive(self.params.region, self.params.branch, self.params.outlet, moment(self.daterange[0]).format('YYYY-MM-DD'), moment(self.daterange[1]).format('YYYY-MM-DD'))
                        //     .then(function (resp) {
                        //         resp.data.data.forEach(element => {
                        //             data.push([element.name, parseInt(element.score)])
                        //         });
                        //         self.chartOptions.width = data.length * 65
                        //         self.chartData = data
                        //         self.loading = false
                        // })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchScore() {
                this.loading2 = true
                var self = this
                api.getScore(this.params.region2, this.params.branch2, this.params.outlet2, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), this.params.is_facility2, this.params.position2, this.params.author2, this.params.authorid2)
                .then(function (response) {
                    let data = [['Wilayah', 'Score']]
                    if(response.data.data.length > 0){
                        response.data.data.forEach(element => {
                            if(element.code!=='999'){
                            data.push([element.name, parseInt(element.score)])
                            }
                        });
                        // self.rows = data
                        self.chartOptions2.width = data.length * 65
                        self.chartData2 = data
                        self.loading2 = false
                    }
                        else {
                            data.push(['No data', 0])
                            self.chartData2 = data
                            self.loading2 = false
                            // api.getScore(self.params.region2, self.params.branch2, self.params.outlet2, moment(self.daterange[0]).format('YYYY-MM-DD'), moment(self.daterange[1]).format('YYYY-MM-DD'))
                            //     .then(function (resp) {
                            //         resp.data.data.forEach(element => {
                            //             data.push([element.name, parseInt(element.score)])
                            //         });
                            //         self.chartOptions2.width = data.length * 65
                            //         self.chartData2 = data
                            //         self.loading2 = false
                            // })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetch() {
                this.loading = true
                var self = this
                api.getReport(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'))
                .then(function (response) {
                    if(response.data.data.length > 0){
                        var data = [['Name', 'Positive Rate', 'Negative Rate']]
                        if(response.data.data.length > 0){
                            response.data.data.forEach(element => {
                                data.push([element.name, parseInt(element.total_good), parseInt(element.total_bad)])
                            });
                            // self.rows = data
                            self.chartOptions.width = data.length * 65
                            self.chartData = data
                            self.loading = false
                        }
                         else {
                             data.push(['No data', 0, 0])
                            self.chartData = data
                        }
                    } else {
                        self.chartData = [],
                        alert('no data')
                        self.loading = false
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchByCategory() {
                this.loading2 = true
                var self = this
                api.getByCategory(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'))
                .then(function (response) {
                    var data = [['Name', 'Positive Rate', 'Negative Rate']]
                    if(response.data.data.length > 0){
                        response.data.data.forEach(element => {
                            data.push([element.name, parseInt(element.good), parseInt(element.bad)])
                        });
                        // self.rows = data
                        self.chartOptions2.width = '100%'
                        self.chartData2 = data
                    } else {
                        data.push(['No data', 0, 0])
                        self.chartData2 = data
                    }
                    self.loading2 = false
                })
                .catch(function (error) {
                    console.log(error);
                    self.loading2 = false
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchTop() {
                this.loading = true
                var self = this
                api.getTop()
                .then(function (response) {
                    var data = []
                    var positive = []
                    var negative = []
                    response.data.data.forEach(element => {
                        data.push({name:element.name, average:element.average, total_rating:element.total_rating})
                        positive.push([element.name, element.total_good])
                        negative.push([element.name, element.total_bad])
                    });
                    self.rows = data
                    self.positive = positive.sort(function(a, b) {
                        return b[1] - a[1];
                    })
                    self.negative = negative.sort(function(a, b) {
                        return b[1] - a[1];
                    })
                    self.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchGeneral() {
                this.loadingPie = true
                var self = this
                api.general()
                .then(function (response) {
                    self.pieData = [
                        ['Positive', response.data.data.avg_good],
                        ['Negative', response.data.data.avg_bad]
                    ]
                    self.pieDataTotal = response.data.data.total
                    self.loadingPie = false
                })
                .catch(function (error) {
                    console.log(error);
                    self.loadingPie = false
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },

            fetchRegions() {
                this.loading = true
                var self = this
                regions.getAll()
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        if(element.code!=='999'){
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                        }
                    });
                    self.regions = regionsx
                    // console.log(self.regions)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchBranches() {
                var self = this
                branches.getAll(this.params.region)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.branches = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchOutlets() {
                var self = this
                outlets.getAll(this.params.region, this.params.branch)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.outlets = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchCategories() {
                var self = this
                categories.getAll()
                .then(function (response) {
                    // 
                    var categories = [];
                    categories.push({id:'-',text:'Posisi'},{id:'0-',text:'Semua Posisi'})
                    response.data.data.forEach(element => {
                        categories.push({
                            id: `${element.is_facility}-${element.name}`,
                            text: element.name
                        });
                    });
                    self.positions = categories
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchUsers() {
                var self = this
                user.getAllUsers(this.params.author)
                .then(function (response) {
                    // 
                    var users = [];
                    response.data.data.forEach(element => {
                        if(element.username!=='rakha'){
                        users.push({
                            id: element.username,
                            text: element.name
                        });
                        }
                    });
                    self.author_ids = users
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchBranches2() {
                var self = this
                branches.getAll(this.params.region2)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.branches2 = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchOutlets2() {
                var self = this
                outlets.getAll(this.params.region2, this.params.branch2)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.outlets2 = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchUsers2() {
                var self = this
                user.getAllUsers(this.params.author2)
                .then(function (response) {
                    // 
                    var users = [];
                    response.data.data.forEach(element => {
                        if(element.username!=='rakha'){
                        users.push({
                            id: element.username,
                            text: element.name
                        });
                        }
                    });
                    self.author_ids2 = users
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            filter1Region(val){
                // console.log(val);
                this.params.region = val
                this.params.branch = ''
                this.branches = []
                this.fetchBranches()
                this.fetchActive()
            },
            filter1Branch(val){
                // console.log(val);
                this.params.branch = val
                this.params.outlet = ''
                this.fetchOutlets()
                this.fetchActive()
            },
            filter1Outlet(val){
                // console.log(val);
                this.params.outlet = val
                this.fetchActive()
            },
            filter1Position(val){
                // console.log(val);
                this.params.is_facility = val.split('-')[0]
                this.params.position = val.split('-')[1]=='Pimpinan'?val.split('-')[1]:val.split('-')[1]
                this.fetchActive()
            },
            filter1Author(val){
                // console.log(val);
                this.params.author = val
                this.params.authorid = ''
                this.fetchActive()
                this.fetchUsers()
            },
            filter1AuthorID(val){
                // console.log(val);
                this.params.authorid = val
                this.fetchActive()
            },
            filter2Region(val){
                // console.log(val);
                this.params.region2 = val
                this.params.branch2 = ''
                this.branches2 = []
                this.fetchBranches2()
                this.fetchScore()
            },
            filter2Branch(val){
                // console.log(val);
                this.params.branch2 = val
                this.params.outlet2 = ''
                this.fetchOutlets2()
                this.fetchScore()
            },
            filter2Outlet(val){
                // console.log(val);
                this.params.outlet2 = val
                this.fetchScore()
            },
            filter2Position(val){
                // console.log(val);
                this.params.is_facility2 = val.split('-')[0]
                this.params.position2 = val.split('-')[1]=='Pimpinan'?val.split('-')[1]:val.split('-')[1]
                this.fetchScore()
            },
            filter2Author(val){
                // console.log(val);
                this.params.author2 = val
                this.params.authorid2 = ''
                this.fetchScore()
                this.fetchUsers2()
            },
            filter2AuthorID(val){
                // console.log(val);
                this.params.authorid2 = val
                this.fetchScore()
            },
            dateChanged() {
                // console.log(this.daterange)
                this.fetchActive()
                this.fetchScore()
            },
            reset() {
                this.branches = []
                this.params = {
                    region: '',
                    branch: '',
                    outlet: ''
                }
                let end = new Date()
                var start = moment(start).subtract(1, 'months')._d;
                this.daterange = [start, end]
                this.fetchActive()
            },
            reset2() {
                this.branches2 = []
                this.params = {
                    region2: '',
                    branch2: '',
                    outlet2: ''
                }
                let end = new Date()
                var start = moment(start).subtract(1, 'months')._d;
                this.daterange = [start, end]
                this.fetchScore()
            }
        },
    }
</script>

<style lang="scss" scoped>
.custom_toolbar {
    display: flex;
    div {
        margin-right: 10px;
    }
}
.el-date-editor .el-range-separator {
    width: 22px !important;
}
.u-text-italic {
    font-style: italic;
}
</style>